import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/site/Layout";
import Home from "@/pages/Home";
import Rentals from "@/pages/Rentals";
import PropertyDetail from "@/pages/PropertyDetail";
import Weddings from "@/pages/Weddings";
import Experiences from "@/pages/Experiences";
import PropertyManagement from "@/pages/PropertyManagement";
import OwnerServices from "@/pages/OwnerServices";
import Reviews from "@/pages/Reviews";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminLogin from "@/pages/AdminLogin";
import AdminReferrals from "@/pages/AdminReferrals";
import { RequireAdmin } from "@/components/site/RequireAdmin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import GuestPortal from "@/pages/GuestPortal";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/rentals" element={<Rentals />} />
          <Route path="/rentals/:id" element={<PropertyDetail />} />
          <Route path="/weddings" element={<Weddings />} />
          <Route path="/experiences" element={<Experiences />} />
          <Route path="/property-management" element={<PropertyManagement />} />
          <Route path="/owner-services" element={<OwnerServices />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/guest" element={<GuestPortal />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
          <Route path="/admin/referrals" element={<RequireAdmin><AdminReferrals /></RequireAdmin>} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </Layout>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
